import { useCallback } from "react"

export function useNativeVibration() {
  const vibrate = useCallback((type: string = "medium") => {
    try {
      window.webkit?.messageHandlers?.mixtape?.postMessage({
        action: "vibrate",
        type,
      })
    } catch (err) {
      console.log("Native vibration not available:", err)
    }
  }, [])

  return vibrate
}
